module.exports = __webpack_public_path__ + "img/sidebar-bg2x.png?5a15807a9d0259073022e25504a9bb01";